import { useState } from "react";
import { Toaster } from "react-hot-toast";
import SalesHeader from "../../components/sales/SalesHeader";
import SalesStats from "../../components/sales/SalesStats";
import SalesTable from "../../components/sales/SalesTable";
import AbandonedCartsTable from "../../components/sales/AbandonedCartsTable";
import Loader from "../../components/common/Loader";
import { useSalesData } from "../../hooks/useSalesData";
import { dictionary } from "../../utils/dictionary";
import { useAuth } from "../../context/AuthContext";

const SalesPage = () => {
  const { filteredOrders, isLoading, activeFilter, activeDateFilter, activeProductFilters, confirmationStatuses, isLoadingStatuses, filterOrders, filterByDate, clearDateFilter, deleteOrder, filterByProductId, removeProductFilter, products, pagination, setPage, setPageSize } = useSalesData();
  const [activeTab, setActiveTab] = useState<"orders" | "abandoned">("orders");
  const { language } = useAuth();

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Loader />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#F5F6FA] px-16 pt-10 pb-16 font-['Plus_Jakarta_Sans']">
      <Toaster position="top-right" />
      <SalesHeader />

      {/* Tabs */}
      <div className="bg-gray-200 rounded-full p-1 flex w-fit mb-6">
        <button
          onClick={() => setActiveTab("orders")}
          className={`px-6 py-2 rounded-full text-sm font-medium transition-all duration-200 ${
            activeTab === "orders"
              ? "bg-white text-gray-900 shadow-sm"
              : "text-gray-500 hover:text-gray-700"
          }`}
        >
          {dictionary["orders-tab"]?.[language]}
        </button>
        <button
          onClick={() => setActiveTab("abandoned")}
          className={`px-6 py-2 rounded-full text-sm font-medium transition-all duration-200 ${
            activeTab === "abandoned"
              ? "bg-white text-gray-900 shadow-sm"
              : "text-gray-500 hover:text-gray-700"
          }`}
        >
          {dictionary["abandoned-carts-tab"]?.[language]}
        </button>
      </div>

      {activeTab === "orders" && filteredOrders && (
        <>
          <SalesStats summary={filteredOrders.summary} />
          <SalesTable
            filterOrders={filterOrders}
            orders={filteredOrders.orders}
            activeFilter={activeFilter}
            onOrderDeleted={deleteOrder}
            onFilterByDate={filterByDate}
            activeDateFilter={activeDateFilter}
            onRemoveDateFilter={clearDateFilter}
            products={products}
            onFilterByProductId={filterByProductId}
            activeProductFilters={activeProductFilters}
            onRemoveProductFilter={removeProductFilter}
            confirmationStatuses={confirmationStatuses}
            isLoadingStatuses={isLoadingStatuses}
            pagination={pagination}
            onPageChange={setPage}
            onPageSizeChange={setPageSize}
          />
        </>
      )}

      {activeTab === "abandoned" && <AbandonedCartsTable />}
    </div>
  );
};

export default SalesPage;
